import { Switch } from '@mantine/core';
import type { ChangeEvent } from 'react';
import { useShallow } from 'zustand/react/shallow';

import type { InsuranceType } from '@/models/insurance.ts';

import type { AppointmentChainConfiguration } from '@/schemas/admin/appointment-chain-configurations.schema.ts';

import { useBookingStore } from '@/stores/bookingStore.ts';

import { filterChainConfigs } from '@/utils/practitioner/bookingFormOptionsUtils.ts';

interface Props {
    practiceId?: string;
    instanceId?: string;
    insuranceType: InsuranceType;
    chainConfigs: AppointmentChainConfiguration[];
    disabled: boolean;
}

export const PatientTypeSwitch = ({ practiceId, instanceId, insuranceType, chainConfigs, disabled }: Props) => {
    const { chainId, isReturning } = useBookingStore(
        useShallow((state) => ({
            chainId: state.chain_selection.chain_id,
            isReturning: state.is_returning_patient,
        }))
    );
    const setIsReturningPatient = useBookingStore((state) => state.setIsReturningPatient);
    const clearChainForPatientType = useBookingStore((state) => state.clearChainForPatientType);

    const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const nextIsReturning = event.currentTarget.checked;
        const compatibleChains = filterChainConfigs(chainConfigs, {
            practiceId: practiceId,
            instanceId: instanceId,
            insuranceType: insuranceType,
            isReturning: nextIsReturning,
        });
        setIsReturningPatient(nextIsReturning);
        if (chainId !== undefined && !compatibleChains.some((c) => c.id === chainId)) clearChainForPatientType();
    };

    return <Switch label="Bestandpatient:in" checked={isReturning} disabled={disabled} onChange={handleChange} />;
};
